// extracted by mini-css-extract-plugin
export default {"texte":"titre_couleur_texte__fwZrH","container":"titre_couleur_container__W76-Y"};